
import { Component, Prop, Vue } from "vue-property-decorator"
import Icon from "../icons/Icon.vue"

@Component({
  components: {
    Icon,
  },
})
export default class PrimaryIconButton extends Vue {
  @Prop({ required: true }) icon!: string
  @Prop() readonly vIcon?: string
  @Prop({ default: "16px" }) readonly iconSize?: string

  get attrs() {
    const { small, ...attrs } = this.$attrs
    return attrs
  }
}
